"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ContentCellFallback = void 0;
var _react = _interopRequireWildcard(require("react"));
var _getRectWidthVariant = require("@cbhq/cds-common/utils/getRectWidthVariant");
var _Box = require("../layout/Box");
var _Fallback = require("../layout/Fallback");
var _Cell = require("./Cell");
var _MediaFallback = require("./MediaFallback");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
const ContentCellFallback = /*#__PURE__*/(0, _react.memo)(function ContentCellFallback({
  title,
  description,
  media,
  meta,
  subtitle,
  disableRandomRectWidth,
  rectWidthVariant
}) {
  // We can't use ContentCell here as we need to account for percentage based widths.
  // Flexbox collides with percentages also, so we need to wrap in normal divs.
  return /*#__PURE__*/_react.default.createElement(_Cell.Cell, {
    media: media && /*#__PURE__*/_react.default.createElement(_MediaFallback.MediaFallback, {
      type: media
    })
  }, /*#__PURE__*/_react.default.createElement("div", {
    style: {
      width: '100%'
    }
  }, meta && /*#__PURE__*/_react.default.createElement("div", {
    style: {
      float: 'right',
      width: '30%'
    }
  }, /*#__PURE__*/_react.default.createElement(_Box.Box, {
    flexShrink: 0,
    justifyContent: "flex-end"
  }, /*#__PURE__*/_react.default.createElement(_Fallback.Fallback, {
    percentage: true,
    disableRandomRectWidth: disableRandomRectWidth,
    height: 18,
    rectWidthVariant: (0, _getRectWidthVariant.getRectWidthVariant)(rectWidthVariant, 0),
    width: 50
  }))), title && /*#__PURE__*/_react.default.createElement(_Fallback.Fallback, {
    percentage: true,
    disableRandomRectWidth: disableRandomRectWidth,
    height: 18,
    rectWidthVariant: (0, _getRectWidthVariant.getRectWidthVariant)(rectWidthVariant, 1),
    width: 45
  }), subtitle && /*#__PURE__*/_react.default.createElement(_Fallback.Fallback, {
    percentage: true,
    disableRandomRectWidth: disableRandomRectWidth,
    height: 16,
    rectWidthVariant: (0, _getRectWidthVariant.getRectWidthVariant)(rectWidthVariant, 2),
    spacingTop: 0.5,
    width: 35
  }), description && /*#__PURE__*/_react.default.createElement(_Fallback.Fallback, {
    percentage: true,
    disableRandomRectWidth: disableRandomRectWidth,
    height: 24,
    rectWidthVariant: (0, _getRectWidthVariant.getRectWidthVariant)(rectWidthVariant, 3),
    spacingTop: 0.5,
    width: 65
  })));
});
exports.ContentCellFallback = ContentCellFallback;